<template lang="pug">
  .component-selectize-vehicle
    loading-spinner(v-if = "loading")
    selectize(v-if="options", :selectedValue="selectedValue", :options="options", value-field="id", :maxItems="maxItems" label-field="plate", :items="items" :searchField="searchableFields", :optionTemplate="optionTemplate", :disabled="disabled", :renderTemplate="renderTemplate", @itemAdded="optionSelected", @itemRemoved="optionRemoved", placeholder="Client Type", :loading="loading")
</template>

<script>
  import KeplerBackofficeSdk from '../../../../../lib/kepler/backoffice'
  import BaseSelectize from './BaseSelectize'
  import Selectize from '../../../Selectize'
  import LoadingSpinner from '../../../LoadingSpinner'

  export default {
    name: 'SelectizeClientType',
    extends: BaseSelectize,
    components: {LoadingSpinner, Selectize},// LoadingSpinner},
    data() {
      return {
        loading: true,
        searchableFields: [
          'id',
          'code',
        ],
      }

    },
    created() {
      KeplerBackofficeSdk.clientTypes.list(1, 1000, null).all((data) => {
        this.options = data.clientTypes
        this.loading = false
      })
    },
    methods: {
      optionTemplate(item, escape) {
        return `<div><div>CT${item.id} ${item.code}</div></div>`
      },
      renderTemplate(item, escape) {
        return `<div><div>CT${item.id} ${item.code}</div></div>`
      },
      optionsLoader() {

      }
    },
    props: ['selectedValue']
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// SelectizeClientType.vue?4fc0f070